// Backend Topics with standardized Event-Types
export const TOPICS = {
  users: {
    topic: "users",
    events: ["UserUpsert", "IdentityUpsert", "CompanyProfileUpsert", "UserAddressUpsert", "IdentityAddressUpsert", "UserSettingsUpsert", "PayoutMethodUpsert", "PayoutMethodDeleted"]
  },
  funded_payouts: {
    topic: "funded_payouts",
    events: ["FundedPayoutUpsert"]
  },
  trading_accounts: {
    topic: "trading_accounts",
    events: ["TradingAccountUpsert", "TradingAccountDeleted", "AccountStatsUpsert"]
  },
  providers: {
    topic: "providers",
    events: ["ProviderUpsert"]
  },
  levels: {
    topic: "levels",
    events: ["LevelProgressUpsert", "LevelEventUpsert"]
  },
  tickets: {
    topic: "tickets",
    events: ["TicketUpsert", "TicketDeleted", "AttachmentUpsert"]
  },
  trades: {
    topic: "trades",
    events: ["TradeUpsert", "TradeDeleted"]
  },
  positions: {
    topic: "positions",
    events: ["PositionUpsert", "PositionDeleted"]
  },
  achievements: {
    topic: "achievements",
    events: ["AchievementUpsert", "AchievementDeleted"]
  },
  partners: {
    topic: "affiliates",
    events: [
      "PartnerUpsert",
      "PartnerDeleted",
      "SettlementUpsert",
      "SettlementDeleted",
      "LinkUpsert",
      "LinkDeleted",
      "CodeUpsert",
      "CodeDeleted",
      "CommissionUpsert",
      "CommissionDeleted",
      "AgreementUpsert",
      "AgreementDeleted"
    ]
  },
  wallet_transactions: {
    topic: "wallet_transactions",
    events: ["WalletTransactionUpsert", "WalletTransactionDeleted", "WalletBucketUpsert", "WalletCategoryUpsert"]
  },
  messages: {
    topic: "messages",
    events: ["MessageUpsert", "ConversationUpsert"]
  },
  notifications: {
    topic: "notifications",
    events: ["NotificationUpsert", "NotificationDeleted"]
  },
  trading_streaks: {
    topic: "trading_streaks",
    events: ["TradingStreakUpsert"]
  },
  level_events: {
    topic: "level_events",
    events: ["LevelEventUpsert", "LevelEventDeleted"]
  },
  funded_contracts: {
    topic: "funded_contracts",
    events: ["FundedContractUpsert"]
  },
  invoices: {
    topic: "invoices",
    events: ["InvoiceUpsert"]
  }
} as const;

export const TOPIC = {
  USER: "users",
  FUNDED_PAYOUTS: "funded_payouts",
  TRADING_ACCOUNTS: "trading_accounts",
  PROVIDERS: "providers",
  LEVELS: "levels",
  LEVEL_EVENTS: "level_events",
  TICKETS: "tickets",
  TRADES: "trades",
  POSITIONS: "positions",
  ACHIEVEMENTS: "achievements",
  PARTNERS: "affiliates",
  WALLET_TRANSACTIONS: "wallet_transactions",
  TRADING_STREAKS: "trading_streaks",
  MESSAGES: "messages",
  NOTIFICATIONS: "notifications",
  FUNDED_CONTRACTS: "funded_contracts",
  INVOICES: "invoices"
} as const;

export type TopicKey = typeof TOPIC[keyof typeof TOPIC];

const _EVENT_TO_TOPIC: Record<string, string> = {};
for (const def of Object.values(TOPICS)) {
  for (const ev of def.events) {
    _EVENT_TO_TOPIC[ev] = def.topic;
  }
}
export const EVENT_TO_TOPIC: Readonly<Record<string, string>> = _EVENT_TO_TOPIC;
